import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import PageContainer from '../../Components/PageContainer'
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import cloudFunctions from '../../Helpers/cloudFunctions';
import { toast } from 'react-toastify';
import CheckoutForm from './CheckoutForm';
import Spinner from '../../Components/Spinner';
import { auth } from '../../firebase';
const stripePromise = loadStripe("pk_test_51L5UaHEgIJbVeIr3GLpEVipkn58ePJ44LfVOlmuG9OhETCl5jXKCh07uEKKmdoYmnSi63LOd74iutcsULRIbRDgt00WWBMBlfr");

export default function Checkout() {
    const [clientSecret, setClientSecret] = useState("")
    const [amount, setAmount] = useState("")
    useEffect(() => {
        if (!auth.currentUser) {
            return window.location.replace("/login")
        }
        cloudFunctions.createSubscription().then((res) => {
            const response = res.data
            if (response.error) {
                toast.error(response.msg)
            } else {
                setClientSecret(response.data.clientSecret)
                setAmount(response.data.price / 100)
            }
        })
    }, [])
    const appearance = {
        theme: 'stripe',
    };
    const options = {
        clientSecret,
        appearance,
    };
    const CheckoutSection = ({ title, children }) => {
        return (
            <div style={{ overflow: "hidden" }} className={`checkoutSection`}>
                <div style={{ cursor: 'pointer', height: 50 }} className="flex aic jcsb">
                    <h2 style={{ fontSize: 22, margin: 0 }}>{title}</h2>
                </div>
                <div style={{ marginTop: 15 }}>
                    {children}
                </div>
            </div>
        )
    }
    return (
        <PageContainer>
            <div style={{ padding: "30px", overflow: "visible" }} className="pgePadd">
                <h1 style={{ marginBottom: 0 }}>Checkout</h1>
                <div className='flex aic' style={{ gap: 5, opacity: .6, marginTop: 10 }}>
                    <svg className='checkoutLockSVG' xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000"><path d="M0 0h24v24H0z" fill="none" /><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" /></svg>
                    <p style={{ fontWeight: "bold", margin: 0 }}>All payments are made over a secure connection</p>
                </div>
                {clientSecret && amount.toString()
                    ? <>
                        <CheckoutSection title={"Your Subscription"}>
                            <div style={{ width: "100%", border: "3px solid rgba(0,0,0,.1)", borderRadius: 10, padding: 20 }} className="bb">
                                <div className='flex aic jcsb' style={{ width: "100%", flexWrap: "wrap" }}>
                                    <div className='flex aic' style={{ gap: 10 }}>
                                        {/* <p style={{ fontWeight: 600 }}>1x</p> */}
                                        <p style={{ fontWeight: 700 }}>SG Polls <span style={{ color: "#0074D9", fontWeight: 800 }}>PRO</span> Subscription</p>
                                    </div>
                                    <p style={{ fontWeight: 700, opacity: .6, marginTop: 0 }}>£{amount}/month</p>
                                </div>
                            </div>
                        </CheckoutSection>
                        <CheckoutSection title={"Payment"}>
                            {clientSecret && (
                                <Elements options={options} stripe={stripePromise}>
                                    <CheckoutForm />
                                </Elements>
                            )}
                        </CheckoutSection>
                    </>
                    : <Spinner />
                }
            </div>
        </PageContainer>
    )
}
